export const transitionBgPrefab = (game) => {
    return game.builder.create({
        type: 'Spine',
        spine: 'transition_bg',
        animation: 'transition_desktop',
        name: 'bonus_game.transition_spine',
        loop: false,
        visible: false,
    });
};

export const secondTransitionBgPrefab = (game) => {
    return game.builder.create({
        type: 'Spine',
        spine: 'BG_transition',
        name: 'bonus_game.intro_popup_spine',
        animation: 'appearance',
        loop: false,
        visible: false,
    });
};
